export default "__VITE_ASSET__CTJXTaKh__"